import { Component, Input, ViewChild } from '@angular/core';
import { Movement } from '../../models/movement.model';
import { DataFormModel } from '../../models/data-form-model.model';
import { FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbCalendar, NgbDatepicker, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { MovementService } from '../../services/movement.service';
import { StreetBuildingService } from '../../services/street-building.service';
import { UtilService } from '../../services/util.service';
import moment from 'moment';
import { AuthService } from '../../services/auth.service';
import { NeighborhoodService } from '../../services/neighborhood.service';

@Component({
  selector: 'app-movement-modal',
  templateUrl: './movement-modal.component.html',
  styleUrl: './movement-modal.component.scss'
})
export class MovementModalComponent {

  @Input() neighborhoodId: string = '';
  @Input() movement?: Movement;

  @Input() yearSelected?: number;
  @Input() monthSelected?: number;

  @ViewChild('dp') dp?: NgbDatepicker;

  public model?: NgbDateStruct;
  public startDate: NgbDateStruct = { 
    year: moment().year(), 
    month: moment().month() + 1, 
    day: moment().date()
  };

	public date?: { year: number; month: number };

  public movementTypes: { value: boolean, label: string }[] = [
    {
      value: true,
      label: 'Ingreso'
    },
    {
      value: false,
      label: 'Egreso'
    }
  ];

  public statusDescription: { value: boolean, label: string }[] = [
    {
      value: false,
      label: 'Pendiente'
    },
    {
      value: true,
      label: 'Completado'
    }
  ];

  public dataForm: DataFormModel = {
    image: {
      value: '',
      type: 'image',
      label: '',
      required: false,
      validators: []
    },
    streetBuildingId: {
      value: null,
      type: 'select',
      idSelect: 'streetBuildingId',
      labelSelect: 'name',
      data: [],
      label: 'Calles',
      placeholder: 'Seleccione la calle (Opcional)',
      requiredMessage: '',
      required: false,
      validators: [],
      onChange: (event: any) => {

        console.log(event);

        if(event) {

          const housesFlats = this.streetBuildingService.streetsBuildings.find(
            (streetBuilding) => streetBuilding.streetBuildingId === event
          );

          if(housesFlats) {

            this.dataForm['houseFlatId'].data = housesFlats.housesFlats;
            this.formMovement.controls['houseFlatId'].setValue(null);

          }

        } else {

          this.dataForm['houseFlatId'].data = [];
          this.formMovement.controls['houseFlatId'].setValue(null);

        }

      }
    },
    houseFlatId: {
      value: null,
      type: 'select',
      idSelect: 'houseFlatId',
      labelSelect: 'number',
      data: [],
      label: 'Casas',
      placeholder: 'Seleccione una casa (Opcional)',
      requiredMessage: '',
      required: false,
      validators: []
    },
    description: {
      value: '',
      type: 'text',
      label: 'Descripción del movimiento',
      requiredMessage: 'Por favor, ingrese una descripción del movimiento',
      required: true,
      validators: [Validators.required]
    },
    notes: {
      value: '',
      type: 'textarea',
      label: 'Notas',
      requiredMessage: '',
      required: false,
      validators: []
    },
    movementType: {
      value: null,
      type: 'select',
      idSelect: 'value',
      labelSelect: 'label',
      data: this.movementTypes,
      label: 'Tipo de movimiento',
      placeholder: 'Seleccione el tipo de movimiento',
      requiredMessage: 'Por favor, seleccione el tipo de movimiento',
      required: true,
      validators: [Validators.required]
    },
    status: {
      value: null,
      type: 'select',
      idSelect: 'value',
      labelSelect: 'label',
      data: this.statusDescription,
      label: 'Estado del movimiento',
      placeholder: 'Seleccione el estado del movimiento',
      requiredMessage: 'Por favor, seleccione el estado del movimiento',
      required: true,
      validators: [Validators.required]
    },
    amount: {
      value: '',
      type: 'text',
      label: 'Monto',
      requiredMessage: 'Por favor, ingrese el monto del movimiento',
      required: true,
      validators: [Validators.required]
    },
  };

  public formMovement!: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;

  public selectedFile: File | null = null;
  public previewUrl: string | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    public authService: AuthService,
    public movementService: MovementService,
    public neighborhoodService: NeighborhoodService,
    public ngbCalendar: NgbCalendar,
    public streetBuildingService: StreetBuildingService,
    public utilService: UtilService,
  ) {
    

  }

  ngOnInit(): void {
    this.loadData();

    if(this.movement) {
      
      const momentDate = moment(this.movement.createdAt).add(
        -6,
        'hours'
      );

      
      this.model = {
        year: momentDate.year(),
        month: momentDate.month() + 1,
        day: parseInt(momentDate.format('D')),
      };

      this.startDate = {
        year: momentDate.year(),
        month: momentDate.month() + 1,
        day: parseInt(momentDate.format('D'))
      };

    } else {

      // console.log(
      //   moment().date()
      // );
      
      this.model = { 
        year: moment().year(), 
        month: moment().month() + 1, 
        day: moment().date()
      };

    }
  }

  get f() {
    return this.formMovement.controls;
  } 

  /*
    ██████╗██████╗ ███████╗ █████╗ ████████╗███████╗
  ██╔════╝██╔══██╗██╔════╝██╔══██╗╚══██╔══╝██╔════╝
  ██║     ██████╔╝█████╗  ███████║   ██║   █████╗
  ██║     ██╔══██╗██╔══╝  ██╔══██║   ██║   ██╔══╝
  ╚██████╗██║  ██║███████╗██║  ██║   ██║   ███████╗
    ╚═════╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async create() {

    const dateAux = {
      years: this.model!.year,
      months: this.model!.month - 1,
      days: this.model!.day,
      hours: moment().hour(),
      minutes: moment().minute(),
      seconds: moment().second(),
    }

    let dateSelected = moment(dateAux);

    console.log(
      dateSelected
    );

    const dateString = dateSelected.format('YYYY-MM-DD HH:mm:ss');

    // console.log(
    //   dateString
    // );

    this.formMovement.value.createdAt = dateString;

    const flag = await this.movementService.create(
      this.formMovement.value,
      this.neighborhoodId,
      this.selectedFile ?? undefined
    );

    if(flag) {
      for(let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }

  }

  /*
  ██╗      ██████╗  █████╗ ██████╗ ██████╗  █████╗ ████████╗ █████╗
  ██║     ██╔═══██╗██╔══██╗██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔══██╗
  ██║     ██║   ██║███████║██║  ██║██║  ██║███████║   ██║   ███████║
  ██║     ██║   ██║██╔══██║██║  ██║██║  ██║██╔══██║   ██║   ██╔══██║
  ███████╗╚██████╔╝██║  ██║██████╔╝██████╔╝██║  ██║   ██║   ██║  ██║
  ╚══════╝ ╚═════╝ ╚═╝  ╚═╝╚═════╝ ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚═╝  ╚═╝

  */
  async loadData() {
    this.loading = true;

    await this.streetBuildingService.getAll(
      this.neighborhoodId
    );

    this.dataForm['streetBuildingId'].data = this.streetBuildingService.streetsBuildings;

    if(this.movement) {

      if(this.movement.houseFlatId) {

        const housesFlats = this.dataForm['streetBuildingId'].data.find(
          (streetBuilding) => streetBuilding.streetBuildingId === this.movement!.streetBuildingId
        )!.housesFlats;

        this.dataForm['houseFlatId'].data = housesFlats;

      }

      this.dataForm = {
        ...this.dataForm,
      }

      for(let key of Object.keys(this.dataForm)) {

        if (key in this.movement!) {
          const standardKey = key as keyof typeof this.movement;
      
          // Ahora puedes acceder a `this.machine[machineKey]` sin errores de tipo.
          this.dataForm[key].value = this.movement[standardKey]!;
        }
      } 
    }
    
    this.formMovement = this.utilService.buildForm(this.dataForm);

    this.loading = false;
  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗██╗     ███████╗ ██████╗██╗  ██╗ █████╗ ███╗   ██╗ ██████╗ ███████╗
  ██╔═══██╗████╗  ██║██╔════╝██║██║     ██╔════╝██╔════╝██║  ██║██╔══██╗████╗  ██║██╔════╝ ██╔════╝
  ██║   ██║██╔██╗ ██║█████╗  ██║██║     █████╗  ██║     ███████║███████║██╔██╗ ██║██║  ███╗█████╗
  ██║   ██║██║╚██╗██║██╔══╝  ██║██║     ██╔══╝  ██║     ██╔══██║██╔══██║██║╚██╗██║██║   ██║██╔══╝
  ╚██████╔╝██║ ╚████║██║     ██║███████╗███████╗╚██████╗██║  ██║██║  ██║██║ ╚████║╚██████╔╝███████╗
   ╚═════╝ ╚═╝  ╚═══╝╚═╝     ╚═╝╚══════╝╚══════╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝

  */
  /**
   * FUNCTION onFileChange
   *
   * @param event
   */
  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      if (file.type.startsWith('image/')) {
        this.previewUrl = URL.createObjectURL(file);
      } else {
        this.previewUrl = null;
      }
    }
  }

  /*
    ██████╗ ███╗   ██╗███████╗██╗   ██╗██████╗ ███╗   ███╗██╗████████╗
  ██╔═══██╗████╗  ██║██╔════╝██║   ██║██╔══██╗████╗ ████║██║╚══██╔══╝
  ██║   ██║██╔██╗ ██║███████╗██║   ██║██████╔╝██╔████╔██║██║   ██║
  ██║   ██║██║╚██╗██║╚════██║██║   ██║██╔══██╗██║╚██╔╝██║██║   ██║
  ╚██████╔╝██║ ╚████║███████║╚██████╔╝██████╔╝██║ ╚═╝ ██║██║   ██║
    ╚═════╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝   ╚═╝

  */
  async onSubmit() {

    console.log(this.formMovement.value);
    
    this.submitted = true;

    if(this.formMovement.invalid) {
      return;
    }

    if(this.movement) {

      await this.update();
    } else {
      await this.create();
    }
  }

  /*
  ██╗   ██╗██████╗ ██████╗  █████╗ ████████╗███████╗
  ██║   ██║██╔══██╗██╔══██╗██╔══██╗╚══██╔══╝██╔════╝
  ██║   ██║██████╔╝██║  ██║███████║   ██║   █████╗
  ██║   ██║██╔═══╝ ██║  ██║██╔══██║   ██║   ██╔══╝
  ╚██████╔╝██║     ██████╔╝██║  ██║   ██║   ███████╗
    ╚═════╝ ╚═╝     ╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝

  */
  async update() {

    // console.log('model', this.model);
    
    this.model = {
      year: this.model!.year,
      month: this.model!.month - 1,
      day: this.model!.day,
    }

    let dateSelected = moment(this.model);
    
    let createdAt = moment(this.movement?.createdAt).add(-6, 'hours');
    
    // console.log(dateSelected.toDate());
    // console.log(createdAt.toDate());
    
    let createdAtFinal = null;
    
    if(
      dateSelected.format('YYYY-MM-DD') === createdAt.format('YYYY-MM-DD')
    ) {
      // console.log('Son iguales');
    } else {
      // console.log('No son iguales');
      createdAtFinal = `${moment(this.model).format('YYYY-MM-DD')} 13:00:00`;
      
      this.formMovement.value.createdAt = createdAtFinal;
    }
    
    this.formMovement.value.neighborhoodId = this.movement!.neighborhoodId;
    this.formMovement.value.movementId = this.movement!.movementId;

    // console.log('formMovement', this.formMovement.value);

    // return;

    const flag = await this.movementService.update(
      this.formMovement.value,
      this.selectedFile ?? undefined
    );

    if(flag) {

      for(let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }
  }

  /*
   ██████╗ ██████╗ ██████╗ ██╗   ██╗██╗   ██╗██████╗ ██╗
  ██╔════╝██╔═══██╗██╔══██╗╚██╗ ██╔╝██║   ██║██╔══██╗██║
  ██║     ██║   ██║██████╔╝ ╚████╔╝ ██║   ██║██████╔╝██║
  ██║     ██║   ██║██╔═══╝   ╚██╔╝  ██║   ██║██╔══██╗██║
  ╚██████╗╚██████╔╝██║        ██║   ╚██████╔╝██║  ██║███████╗
   ╚═════╝ ╚═════╝ ╚═╝        ╚═╝    ╚═════╝ ╚═╝  ╚═╝╚══════╝

  */
  // region copyUrl
  copyUrl(
    url: string
  ): void {
    navigator.clipboard.writeText(url);
  }

}
